import { publishedHtmlAxiosPathFromApiPath } from '@/utils/publishing'

import { apiClientVersioned, returnData } from '../index'

interface IPublishHtmlResponse {
  key: string
  /** Path under API root, e.g. `/api/v1/publishing/html/{chat}/{message}/{uuid}.html` */
  url: string
  chat_id: string
  message_id: string
  block_index: number
}

interface IPublishHtmlBody {
  title?: string
}

export const PublishingApi = {
  publishHtml: (publishPath: string, body?: IPublishHtmlBody) =>
    returnData(
      apiClientVersioned.post<IPublishHtmlResponse>(
        publishPath.startsWith('/') ? publishPath : `/${publishPath}`,
        body ?? {},
      ),
    ),

  /** GET published HTML; uses the same auth interceptors as other API calls (EVGPT-1275). */
  getPublishedHtml: (apiPath: string) =>
    returnData(
      apiClientVersioned.get<string>(
        publishedHtmlAxiosPathFromApiPath(apiPath),
        {
          responseType: 'text',
        },
      ),
    ),
}
